import { ChatCommandEvent, MessageAction } from '../constants/enums'
import { locales } from '../locales/en'
import { FCTYPE_PMESG } from '../mfcLogic/mfcConstants'
import { setPMChatWasPMCommandUsedState } from '../state/internal/pms'
import { pubSubChatCommands } from '../state/pubSub'
import { loadUserIfNeeded } from './loadUserIfNeeded'
import { openError } from './openError'
import { messageAction } from './workerActions'

export const sendPrivateMessage = async (
    id: number,
    message = '',
    pmCommand?: boolean,
) => {
    if (message.trim().length === 0) return
    const user = await loadUserIfNeeded(id)
    if (!user) {
        openError({
            message: locales.chat.pmWithoutValidUsername,
        })
        return
    }

    if (pmCommand !== undefined) {
        setPMChatWasPMCommandUsedState(id, pmCommand)
    }

    if (message.startsWith('/')) {
        const payload = {
            message,
            user,
            chatType: FCTYPE_PMESG,
        }
        pubSubChatCommands.emit(ChatCommandEvent.GENERATE_COMMANDS, payload)
    } else {
        messageAction(MessageAction.SEND_MESSAGE, { id: user.id, message })
    }
}
